import axios from '@/api/requests/axios'

export default {
  getAll: () => axios.get('/api/admin/v1/appliance-rules'),
  getById: id => axios.get(`/api/admin/v1/appliance-rules/${id}`),

  getOptions: () => axios.get('/api/admin/v1/appliance-rules/options'),
  create: rule => axios.post('/api/admin/v1/appliance-rules', rule),
  update: rule => axios.put('/api/admin/v1/appliance-rules', rule),
  delete: id => axios.delete(`/api/admin/v1/appliance-rules/${id}`),
}
